"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Success = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../assets/js/constants");
var Success = function () {
    return (react_1.default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '56', height: '56', fill: 'none' },
        react_1.default.createElement("path", { fill: constants_1.COLORS.GREEN, fillRule: 'evenodd', d: 'M54.5 28a26.5 26.5 0 1 1-53 0 26.5 26.5 0 0 1 53\n                 0Zm1.5 0a28 28 0 1 1-56 0 28 28 0 0 1 56 0Zm-17.3-5.03a.75.75\n                 0 0 0-1.07-1.06L25.32 34.23 19.9 28.8a.75.75 0 0 0-1.06 1.06l5.95\n                 5.95.53.53.53-.53 12.84-12.85Z', clipRule: 'evenodd' })));
};
exports.Success = Success;
